import script from "./Content.vue?vue&type=script&setup=true&lang=js"
export * from "./Content.vue?vue&type=script&setup=true&lang=js"

import "./Content.vue?vue&type=style&index=0&id=4ca0149a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ca0149a"]])

export default __exports__